import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.107 5.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779zM3 7.921V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.426 5.9a1 1 0 0 1-1.147 0zM4 3C2.348 3 1 4.348 1 6v12c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6c0-1.652-1.348-3-3-3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }